var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:_vm.ulClass},_vm._l((_vm.links),function(link,index){return _c('li',{key:index},[_c('a',{attrs:{"target":"_blank","href":_vm.baseUrl + link.href}},[_vm._v(_vm._s(link.title))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }